// 日历组件 by guniang 20210801
<template>
  <div class="date__picker" v-click-out-side>
    <div class="date__input-container">
      <img class="rili" src="@/assets/images/1/rili.png" alt="">
      <input type="text" :value="formatDate">
      <img class="select" src="@/assets/images/1/juxing.png" alt="">
    </div>
    <div class="date__pannel" v-if="isVisable">
      <div class="pannel__nav">
        <div class="prev__container">
          <span @click="prevMonth">&lt;</span>
        </div>
        <div v-if="lan==='zh_CN'" class="content__container">
          <span>{{time.year}}年</span>
          <span>{{time.month + 1}}月</span>
        </div>
        <div v-else class="content__container">
          <span>{{month}}  </span>
          <span>{{time.year}}</span>
        </div>
        <div class="next__container">
          <span @click="nextMonth">&gt;</span>
        </div>
      </div>
      <div class="pannel__content">
        <div class="days">
          <span v-for="j in 7" :key="'_' + j" class="cell">
            {{weekDays[j-1]}}
          </span>
          <!-- 列出6*7列表 -->
          <div class="cell__container" v-for="i in 6" :key="i">
            <!-- 不是当月 渲染灰色 -->
            <span
              class="cell cell-days"
              @click="onChangeDate(visabledDays[(i - 1) * 7 + (j - 1)])"
              v-for="j in 7"
              :key="j"
              :class="[
                {notCurrentMonth: !isCurrentMonth(visabledDays[(i - 1) * 7 + (j - 1)])},
                {today: isToday(visabledDays[(i - 1) * 7 + (j - 1)])},
                {select: isSelect(visabledDays[(i - 1) * 7 + (j - 1)])}
              ]">
              {{visabledDays[(i - 1) * 7 + (j - 1)].getDate()}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'c-date-picker',
  props: {
    value: {
      type: Date,
      default: () => new Date(),
    },
  },
  data() {
    const { year, month } = this.getYearMonthDate(this.value);
    return {
      isVisable: false, // 控制面板是否可见
      time: {
        year,
        month,
      },
    };
  },
  directives: {
    clickOutSide: { // 指令的生命周期
      bind(el, bindings, vnode) {
        // 把事件绑定在document上
        const handler = (e) => {
          if (el.contains(e.target)) {
            // 判断一下是否当前面板已经显示出来了
            if (!vnode.context.isVisable) {
              vnode.context.focus();
            }
          } else if (vnode.context.isVisable) {
            vnode.context.blur();
          }
        };
        // eslint-disable-next-line no-param-reassign
        el.handler = handler;
        document.addEventListener('click', handler);
      },
      unbind(el) {
        document.removeEventListener('click', el.handler);
      },
    },
  },
  computed: {
    lan() {
      return this.$store.state.baseData.lan;
    },
    weekDays() {
      return this.$t('common.date');
    },
    month() {
      return this.$t('common.months')[this.time.month];
    },

    formatDate() {
      const { year, month, day } = this.getYearMonthDate(this.value);
      return `${year}-${month + 1}-${day}`;
    },
    visabledDays() {
      // 获取当前是周几
      const { year, month } = this.getYearMonthDate(
        this.getDate(this.time.year, this.time.month, 1),
      );
      // 获取当前月份第一天
      const currentFirstDay = this.getDate(year, month, 1);
      // 获取当前是周几 把天数往前移动几天
      const week = currentFirstDay.getDay();
      // 当前开始的天数
      const startDay = currentFirstDay - week * 60 * 60 * 1000 * 24;
      // 循环42天
      const arr = [];
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < 42; i++) {
        // 依次循环出42天
        arr.push(new Date(startDay + i * 60 * 60 * 1000 * 24));
      }
      return arr;
    },
  },
  methods: {
    // 获取年月日
    getYearMonthDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth();
      const day = date.getDate();
      return { year, month, day };
    },
    // 日期化
    getDate(year, month, day) {
      return new Date(year, month, day);
    },
    focus() {
      this.isVisable = true;
    },
    blur() {
      this.isVisable = false;
    },
    isCurrentMonth(date) {
      // 是否为当月日期
      // eslint-disable-next-line max-len
      const { year, month } = this.getYearMonthDate(this.getDate(this.time.year, this.time.month, 1));
      const { year: y, month: m } = this.getYearMonthDate(date);
      return year === y && month === m;
    },
    isToday(date) {
      // 是否为当月日期
      const { year, month, day } = this.getYearMonthDate(new Date());
      const { year: y, month: m, day: d } = this.getYearMonthDate(date);
      return year === y && month === m && day === d;
    },
    isSelect(date) {
      // 获取当前的年月日
      const { year, month, day } = this.getYearMonthDate(this.value);
      const { year: y, month: m, day: d } = this.getYearMonthDate(date);
      return year === y && month === m && day === d;
    },
    prevMonth() {
      // 获取当前月的一个日期
      const d = this.getDate(this.time.year, this.time.month, 1);
      d.setMonth(d.getMonth() - 1);
      this.time = this.getYearMonthDate(d);
    },
    nextMonth() {
      // 获取当前月的一个日期
      const d = this.getDate(this.time.year, this.time.month, 1);
      d.setMonth(d.getMonth() + 1);
      this.time = this.getYearMonthDate(d);
    },
    // 选择日期
    onChangeDate(date) {
      this.time = this.getYearMonthDate(date);
      // eslint-disable-next-line no-console
      // console.log(date, 'data------->');
      this.$emit('input', date);
      this.blur(); // 关闭面板
    },
  },
};
</script>

<style lang="stylus" scoped>
.date__pannel {
  position absolute;
  color: #000000d9;
  font-size: 14px;
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px #0000001f, 0 6px 16px #00000014, 0 9px 28px 8px #0000000d;
  transition: margin .3s;
  border: 1px solid #f0f0f0;
  z-index 1000;
}
.date__input-container {
  width: 132px;
  height: 26px;
  border: 0.5px solid rgba(51, 51, 51, 0.3);
  border-radius: 2px;
  display: flex;
  align-items: center;
  padding: 0 5px;
  box-sizing: border-box;
  cursor: pointer;
}
.date__input-container  input{
  width 100%;
  height 100%;
  padding: 0 8px;
  box-sizing: border-box;
  color: #737373;
}
.date__input-container  .rili{
  width 14px;
  height 14px;
  display block;
}
.date__input-container  .select{
  width: 18px;
  height: 7px;
  display: block;
}
.pannel__nav {
  display flex;
  justify-content space-around;
  align-items: center;
  height 40px;
  border-bottom 1px solid #f0f0f0;
  user-select: none;
}
.days {
  padding: 8px 12px;
}
.cell {
  display inline-flex;
  justify-content center;
  align-items center;
  width 36px;
  height 24px;
  padding 3px 0;
  cursor pointer;
}
.cell-days:hover {
  background: #f5f5f5;
}
.notCurrentMonth {
  color: #00000040;
}
.cell.today {
  border: 1px solid #1890ff;
}
.cell.select {
  color: #fff;
  background: #1890ff;
  border: 1px solid transparent;
}
.prev__container, .next__container {
  cursor pointer;
}
</style>
